// extracted by mini-css-extract-plugin
export default {"container":"NewItem_container__-Y3wY"};